import clsx from "clsx";
import { FC } from "react";
import { useTranslation } from "rujira.ui";
import { useRedactedV2 } from "../../../redacted/v2";
import { privacyView } from "./privacyDisplay";
import { usePrivacyLearnMore } from "./PrivacyLearnMore";
import { levelLabel, meterLabel } from "./privacyText";
import { PrivacyTrack } from "./PrivacyTrack";

/**
 * One asset's Reserve privacy in the portfolio table: the dotted track with
 * a knob at the label's fixed position, filling the column the public list
 * gives its networks, then the label with the partly-public chip under it.
 * Phones show the label and the chip only. Hover or focus shows "Estimated
 * on-chain privacy, not a guarantee."; a click opens "Learn more" for this
 * asset. The button's name carries everything for screen readers.
 */
export const PrivacyMeter: FC<{ denom?: string; symbol: string }> = ({
  denom,
  symbol,
}) => {
  const { t } = useTranslation("portfolio");
  const { privacy } = useRedactedV2();
  const learnMore = usePrivacyLearnMore(denom ? { denom, symbol } : undefined);
  const view = privacyView(
    denom ? privacy.byDenom.get(denom) : undefined,
    privacy.checking
  );
  return (
    <button
      type="button"
      className={clsx("privacy-meter", `privacy-meter--${view.tone}`, {
        "privacy-meter--checking": view.checking,
        "privacy-meter--linked": view.linkDetected,
      })}
      data-tooltip-id="global-tip"
      data-tooltip-content={t("privacyEstimate")}
      {...learnMore}>
      {view.linkDetected && (
        <span className="privacy-meter__alert" aria-hidden="true" />
      )}
      <PrivacyTrack tone={view.tone} checking={view.checking} />
      <span className="privacy-meter__text" aria-hidden="true">
        <span className="privacy-meter__label">{levelLabel(t, view)}</span>
        {view.partlyPublic && (
          <span className="privacy-chip">{t("privacyPartlyPublic")}</span>
        )}
      </span>
      <span className="visually-hidden">{meterLabel(t, view)}</span>
    </button>
  );
};
